import { $, _ } from "js/vendor";

export function RemoveSplashScreen(fade) {
    if (fade) {
        _.delay(() => {
            $("#splash").velocity("transition.fadeOut", {
                complete: () => {
                    $("#splash").remove();
                }
            });
        }, 300);
    } else {
        $("#splash").remove();
    }
}

